import client from "./client";

const ADMIN_BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL || "http://localhost:9082";

/** 노출중인 메인페이지 배너 목록 (관리자에서 등록, 노출순서대로) */
export async function getBanners() {
  const res = await client.get("/banner");
  return res.data;
}

/** 배너 이미지는 admin 모듈이 배너ID 기준으로 서빙한다 (상품 이미지와 동일한 방식). */
export function bannerImageUrl(bannerId) {
  return `${ADMIN_BASE_URL}/admin/banner/${bannerId}/image`;
}
